export default __webpack_public_path__ + "static/media/profilePic.7e04d3ac.jpeg";